export default function conferenceReducer(conference, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...conference, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "ringSeconds":
      return { ...conference, [action.type]: Number(action.value) };
    case "repeat":
      return { ...conference, [action.type]: action.value ? Number(action.value) : 0 };

    default:
      return { ...conference, [action.type]: action.value };
  }
}
